// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1aS_s","colMaxWidth":"Table_colMaxWidth__18kwO"};